export default "__VITE_ASSET__BM$JsH8I__"